export default {
    WORKFLOW_STATUS: {
        DELETED: 'DELETED',
        INSERTED: 'INSERTED',
        UPDATED: 'UPDATED',
    },
    TYPE: {
        CURRENT: 'Current',
        EXPIRED: 'Expired',
    },
    STATUS: {
        ACTIVE: 'Active',
        DRAFT: 'Draft',
    },
};
